module.exports = __webpack_public_path__ + "static/media/lutron_black.03c5b0d8.png";